import { render, staticRenderFns } from "./CreateALiteracyBadge.vue?vue&type=template&id=0ff43918&scoped=true"
import script from "./CreateALiteracyBadge.vue?vue&type=script&lang=js"
export * from "./CreateALiteracyBadge.vue?vue&type=script&lang=js"
import style0 from "./CreateALiteracyBadge.vue?vue&type=style&index=0&id=0ff43918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff43918",
  null
  
)

export default component.exports